import { HeaderPanel } from '@metrika/ui-kit/carbon';
import React, { ReactChild, ReactChildren } from 'react';

interface OverlayHeaderPanelProps {
   expanded: boolean;
   onClick: () => void;
   'aria-label': string;
   children: ReactChild | ReactChildren;
}
const OverlayHeaderPanel: React.FC<OverlayHeaderPanelProps> = (props) => {
   const rightSideBarOverlayClasses = ['cds--side-nav__overlay'];
   if (props.expanded) {
      rightSideBarOverlayClasses.push('cds--side-nav__overlay-active');
   }

   return (
      <div>
         {/* the right nav bar doesn't make its own overlay, so we make one ourselves*/}
         <div data-testid="overlaydiv" className={rightSideBarOverlayClasses.join(' ')} onClick={props.onClick} />
         <HeaderPanel aria-label="User Information Panel" expanded={props.expanded}>
            {props.children}
         </HeaderPanel>
      </div>
   );
};

export default OverlayHeaderPanel;
